import styled from 'styled-components';

export default styled.div`
    width:100%;
    margin-bottom:50px;
    h2{
    color:var(--color-azul);
    }
`;